import SuperCluster from 'supercluster'

const state = {
  listKapal: {
    type: 'FeatureCollection',
    features: [],
    cluster: null,
    total: 0
  },
  kapal: {},
  filter: {
    'h24-on': {
      id: 'h24-on',
      title: 'Kapal Aktif 24 Terakhir',
      match: (prop) => prop.status === 1
    },
    'h24-off': {
      id: 'h24-off',
      title: 'Kapal Tidak Aktif',
      match: (prop) => prop.status === 0
    }
  },
  activeFilter: {
    id: null,
    title: null,
    match: null,
    index: null,
    validate: () => true
  },
  optionalFilter: {
    nama_perusahaan: '',
    jenis_alat_tangkap: ''
  },
  customFilter: {
    current_wpp: null
  }
}

const getters = {
  listKapal: (state) => state.listKapal,
  kapal: (state) => state.kapal,
  filter: (state) => state.filter,
  activeFilter: (state) => state.activeFilter,
  optionalFilter: (state) => state.optionalFilter,
  customFilter: (state) => state.customFilter
}

const actions = {
  toLoadListKapal: async ({ state, commit, dispatch }, { offset = null, limit = null } = {}) => {
    commit('setMapControl', {
      inload: true,
      completeload: false
    })

    let offsetLimit = ''

    if (offset !== null && limit !== null) {
      offsetLimit = `offset=${offset}&limit=${limit}`
    }

    let listKapal = await dispatch('authenticatedApi', {
      method: 'get',
      url: `${window.config.BASEURL_API1}/kapal/list?${offsetLimit}`
    })

    if (listKapal) {
      // make cluster list kapal
      let calculatePoint = {
        heighst: 0,
        medium: 0
      }
      let currentPoint = 0

      const kapalCluster = new SuperCluster({
        maxZoom: 16,
        radius: 92,
        reduce: (clusterProp) => {
          if (clusterProp.calculate) {
            currentPoint += 1

            if (currentPoint > clusterProp.calculate.heighst) {
              clusterProp.calculate.heighst = currentPoint
            } else if (currentPoint > clusterProp.calculate.medium) {
              clusterProp.calculate.medium = currentPoint
            }
          } else {
            currentPoint = 1

            clusterProp.calculate = calculatePoint
          }
        }
      })

      const filtered = []
      const filterNamaPerusahaan = new RegExp(state.optionalFilter.nama_perusahaan, 'ig')
      const filterJenisAlatTangkap = new RegExp(state.optionalFilter.jenis_alat_tangkap, 'ig')

      for (var kapal of listKapal.data.kapal) {
        if (state.activeFilter.validate(kapal.properties) &&
          kapal.properties.nama_perusahaan.match(filterNamaPerusahaan) &&
          kapal.properties.jenis_alat_tangkap.match(filterJenisAlatTangkap)) {
          filtered.push(kapal)
        }
      }

      kapalCluster.load(filtered)

      commit('setListKapal', {
        data: listKapal.data,
        cluster: kapalCluster
      })
    }

    commit('setMapControl', {
      inload: false
    })
  },
  toLoadKapal: async ({ commit, dispatch }, nomorTransmitter) => {
    commit('setLoading', 'memuat data kapal')

    let dataKapal = await dispatch('authenticatedApi', {
      method: 'get',
      url: `${window.config.BASEURL_API1}/kapal/data?transmitter=${nomorTransmitter}`
    })

    if (dataKapal) {
      commit('setKapal', dataKapal.data.kapal.properties)
    }

    commit('unsetLoading')
  }
}

const mutations = {
  setListKapal: (state, { data = {}, cluster = null }) => {
    state.listKapal.features = data.kapal || []
    state.listKapal.total = data.total
    state.listKapal.cluster = cluster
  },
  setKapal: (state, kapal) => state.kapal = kapal,
  setActiveFilter: (state, filterIndex) => {
    state.activeFilter.id = state.filter[filterIndex].id
    state.activeFilter.title = state.filter[filterIndex].title
    state.activeFilter.match = state.filter[filterIndex].match
    state.activeFilter.index = filterIndex

    state.activeFilter.validate = (prop) => {
      return state.activeFilter.match(prop)
    }
  },
  setOptionalFilter: (state, filter) => {
    state.optionalFilter[filter.index] = filter.value
  },
  setCustomFilter: (state, filter) => {
    state.customFilter[filter.index] = filter.value
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
